import combineStyles from 'components/Templates/general/combineStyles';

import {
  wrapperStyles,
  buttonsCenterWrapper,
} from 'components/Templates/commonStyles/DefaultCssValues';

import {
  sectionWrapperStyles,
  sectionWrapperTabletStyles,
  sectionWrapperMobileStyles,
  wrapperWithMarginStyles,
  wrapperWithMarginTabletStyles,
  typoHeader,
  typoHeaderMobile,
  typoParagraph
} from 'components/Templates/styles/Red/commonObjectsStyles';

import buttonStyles from 'components/Templates/styles/Red/buttonStyles';


/* eslint-disable */
const thisStyle = {
  wrapper: {
    '0': {
      ...wrapperStyles,
      ...sectionWrapperStyles,
      'background-color' : '{invertedBackgroundColor}'
    },
    '76_8' : {
      ...sectionWrapperTabletStyles
    },
    '37_5' : {
      ...sectionWrapperMobileStyles
    }
  },
  wrapperWithMargin: {
    '0': {
      ...wrapperWithMarginStyles
    },
    '76_8' : {
      ...wrapperWithMarginTabletStyles
    }
  },
  sectionTitle: {
    '0': {
      ...typoHeader,
    'margin-bottom' : '6rem',
    'color': '{lightSecondaryTextColor}'
    },
    '76_8' : {
      ...typoHeaderMobile,
      'color': '{lightSecondaryTextColor}'
    },
  },
  paragraph: {
    '0': {
      ...typoParagraph,
      'width': '50%',
      'margin-bottom' : '5rem',
      'color': '{lightTextColor}'
    },
    '76_8' : {
      'width': '100%',
      'margin-bottom' : '3rem',
      'color': '{lightTextColor}'
    }
  },
  buttonsCenterWrapper: {
    '0': {
      ...buttonsCenterWrapper,
      'margin-top' : '6rem',
      'margin-right' : '0',
      'justify-content': 'left',
      'flex-wrap': 'wrap'
    },
    '37_5' : {
      'margin-top' : '3rem',
      'margin-right' : 'auto',
      'flex-direction' : 'column',
      'justify-content': 'center'
    }
  }
};

export default combineStyles(thisStyle, buttonStyles);
